# frozen_string_literal: true

require_relative 'sell_company'

module Engine
  module Action
    class CorporateSellCompany < SellCompany
    end
  end
end
